import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from './createBaseQuery';

export interface IBanner {
  id: string;
  coverUrl: string;
  mobileCoverUrl: string;
  href: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateBannerRequest {
  coverUrl: string;
  mobileCoverUrl: string;
  href: string | null;
  isActive: boolean;
}

export interface UpdateBannerRequest extends Partial<CreateBannerRequest> {
  id: string;
}

export const bannersApi = createApi({
  reducerPath: 'bannersApi',
  baseQuery: createBaseQuery(),
  tagTypes: ['Banners'],
  endpoints: (builder) => ({
    getBanners: builder.query<IBanner[], void>({
      query: () => ({
        url: '/banners',
        method: 'GET',
      }),
      providesTags: ['Banners'],
    }),


    getAdminBanners: builder.query<IBanner[], void>({
      query: () => ({
        url: '/admin/banners',
        method: 'GET',
      }),
      providesTags: ['Banners'],
    }),

    createBanner: builder.mutation<IBanner, CreateBannerRequest>({
      query: (body) => ({
        url: '/admin/banners',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Banners'],
    }),

    updateBanner: builder.mutation<IBanner, UpdateBannerRequest>({
      query: ({ id, ...body }) => ({
        url: `/admin/banners/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Banners'],
    }),

    deleteBanner: builder.mutation<void, string>({
      query: (id) => ({
        url: `/admin/banners/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Banners'],
    }),
  }),
});

export const {
  useGetBannersQuery,
  useGetAdminBannersQuery,
  useCreateBannerMutation,
  useUpdateBannerMutation,
  useDeleteBannerMutation,
} = bannersApi; 